<template>
  <form
    method="post"
    novalidate
    autocomplete="off"
    @submit.prevent="handleAddNewMember"
  >
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="firstName">
            First Name
            <span class="text-danger">*</span>
          </label>
          <input
            id="firstName"
            type="text"
            name="firstName"
            v-validate="'required|regex:^[A-Za-z\\s]*$'"
            v-model.trim="memberForm.firstName"
            data-vv-as="first name"
            placeholder="Enter first name"
            class="form-control"
            required
            @input="generateDisplayName"
          />
          <div v-if="veeErrors.first('firstName')" class="invalid-feedback">
            {{ veeErrors.first("firstName") }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="lastName">
            Last Name
            <span class="text-danger">*</span>
          </label>
          <input
            id="lastName"
            type="text"
            name="lastName"
            v-validate="'required|regex:^[A-Za-z\\s]*$'"
            v-model.trim="memberForm.lastName"
            data-vv-as="last name"
            placeholder="Enter last name"
            class="form-control"
            required
          />
          <div v-if="veeErrors.first('lastName')" class="invalid-feedback">
            {{ veeErrors.first("lastName") }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="displayName">
            Display Name
          </label>
          <input
            id="displayName"
            type="text"
            name="displayName"
            v-validate="'required|regex:^[A-Za-z\\s]*$'"
            v-model.trim="memberForm.displayName"
            data-vv-as="display display name"
            placeholder="Enter display name"
            class="form-control"
          />
          <div v-if="veeErrors.first('displayName')" class="invalid-feedback">
            {{ veeErrors.first("displayName") }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="email">
            Email
            <span class="text-danger">*</span>
          </label>
          <input
            type="email"
            name="email"
            v-validate="
              'required|email|uniqueEmail|regex:^([A-Za-z\\d]+[-_\.]?)+@([^\\s@])+\.([^\\s@])+$'
            "
            v-model.trim="memberForm.email"
            data-vv-delay="500"
            data-vv-as="email"
            placeholder="Enter email address"
            class="form-control"
            :disabled="editMember"
            required
          />
          <div v-if="veeErrors.first('email')" class="invalid-feedback">
            {{ veeErrors.first("email") }}
          </div>
        </div>
      </div>
      <template v-if="editMember == false">
        <div class="col-md-6">
          <div class="form-group">
            <label for="password">
              Password
              <span class="text-danger">*</span>
            </label>
            <div class="password-wrapper">
              <input
                id="password"
                ref="password"
                :type="isToggled ? 'text' : 'password'"
                name="password"
                v-validate="'required|verify_input|min:6|max:100'"
                v-model="memberForm.password"
                data-vv-as="password"
                placeholder="Enter password"
                :class="`form-control ${passwordMatched}`"
                required
              />
              <img
                src="~@/assets/media/icons/visibility.svg"
                alt="visibility icon"
                @click="handleTogglePasswordClick"
                :class="isToggled ? 'is-visible' : ''"
              />
            </div>
            <div v-if="veeErrors.first('password')" class="invalid-feedback">
              {{ veeErrors.first("password") }}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="confirmPassword">
              Confirm Password
              <span class="text-danger">*</span>
            </label>
            <div class="password-wrapper">
              <input
                id="confirmPassword"
                :type="isToggled ? 'text' : 'password'"
                name="confirmPassword"
                v-validate="
                  'required|confirmed:password|verify_input|min:6|max:100'
                "
                v-model="memberForm.confirmPassword"
                data-vv-as="password"
                placeholder="password"
                :class="`form-control ${passwordMatched}`"
                required
              />
              <img
                src="~@/assets/media/icons/visibility.svg"
                alt="visibility icon"
                @click="handleTogglePasswordClick"
                :class="isToggled ? 'is-visible' : ''"
              />
            </div>
            <div
              v-if="veeErrors.first('confirmPassword')"
              class="invalid-feedback"
            >
              {{ veeErrors.first("confirmPassword") }}
            </div>
          </div>
        </div>
      </template>
      <div class="col-md-6">
        <div class="form-group">
          <label for="phoneNumber">
            Phone Number
          </label>
          <input
            id="phoneNumber"
            type="text"
            name="phone"
            v-validate="'numeric'"
            v-model.trim="memberForm.mobile"
            data-vv-as="mobile"
            placeholder="Enter phone number"
            class="form-control"
          />
          <div v-if="veeErrors.first('phone')" class="invalid-feedback">
            {{ veeErrors.first("phone") }}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="userRole">
            Access Level
            <span class="text-danger">*</span>
          </label>
          <v-select
            id="userRole"
            :options="userRoles"
            :selected="memberForm.role"
            :class="{ 'is-invalid': veeErrors.first('userRole') }"
            v-model="memberForm.role"
            v-validate="'required'"
            data-vv-as="access level"
            label="name"
            name="userRole"
            placeholder="Select Access Level"
            required
          />
          <div v-if="veeErrors.first('userRole')" class="invalid-feedback">
            {{ veeErrors.first("userRole") }}
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group text-right mb-0">
          <ActionButton
            :label="null"
            type="submit"
            :theme="{ primary, secondary, event, danger }"
            :disabled="isLoading || !isFormDirty"
            class="form__submit-button ml-auto"
          >
            <Spinner v-if="isLoading" theme="currentColor" />
            <span v-else>{{ btnLabel }}</span>
          </ActionButton>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { Validator } from "vee-validate";
import axios from "@/helpers/axios";
import Color from "color";
import { mapActions } from "vuex";
import { socketSender } from "@/helpers/socket";

const ActionButton = () => import("@/components/ActionButton");
const Spinner = () => import("@/components/Spinner");

export default {
  components: {
    ActionButton,
    Spinner
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: true,
      currentUser:
        this.$store.getters.getUser.firstName +
        " " +
        this.$store.getters.getUser.lastName,
      passwordMatched: "valid",
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      memberForm: {
        displayName: null,
        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        password: null,
        confirmPassword: null,
        role: null
      },
      selectedUserRole: "Member",
      userRoles: [],
      isToggled: false,
      btnLabel: "Create",
      editMember: false,
      editMemberId: null,
      singleMember: null
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    isFormDirty() {
      return Object.keys(this.veeFields).some(key => this.veeFields[key].dirty);
    }
  },
  created() {
    this.fetchRoles();
    this.editSelectedMember();
  },
  mounted() {
    const isUniqueEmailAsync = email =>
      axios
        .get(`/users?email=${email}&paranoid=false`)
        .then(res => res.data.data)
        .then(data => {
          if (!data) return { valid: true };
          return {
            valid: false,
            data: { message: `${email} is already taken.` }
          };
        });

    Validator.extend("uniqueEmail", {
      validate: isUniqueEmailAsync,
      getMessage: (field, params, data) => data.message
    });

    Validator.extend("verify_input", {
      getMessage: "Password format is invalid",
      validate: value => {
        let regex = new RegExp(
          /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/
        );
        return !regex.test(value);
      }
    });

    this.$nextTick(() => {
      this.$set(this.$data, "isLoading", false);
    });
  },
  methods: {
    ...mapActions({
      USER_ADD: "USER_ADD",
      USER_EDIT: "USER_EDIT",
      USER_SET_TAB: "USER_SET_TAB"
    }),
    editSelectedMember() {
      if (this.singleRecord) {
        this.singleMember = this.singleRecord;
        let singleMember = this.singleRecord;

        this.memberForm.displayName = singleMember.displayName;
        this.memberForm.firstName = singleMember.firstName;
        this.memberForm.lastName = singleMember.lastName;
        this.memberForm.email = singleMember.email;
        this.memberForm.mobile = singleMember.mobile;
        this.memberForm.role = singleMember.Roles[0];
        this.editMemberId = singleMember.id;
        this.editMember = true;
        this.btnLabel = "Update";
      }
    },
    async handleAddNewMember() {
      try {
        this.$set(this.$data, "isLoading", true);
        const isFormValid = await this.$validator.validateAll();

        // Stop further execution for invalid form.
        if (!isFormValid) {
          throw new Error("Unable to submit form. Try again.");
        }

        // Build user object.
        const { role, confirmPassword, ...form } = { ...this.memberForm };
        const background = "000000".replace(/0/g, function() {
          return (~~(Math.random() * 16)).toString(16);
        });
        const color = Color("#" + background).isLight ? "fff" : "333";
        form.avatar = `https://ui-avatars.com/api/?name=${this.memberForm.firstName}
        +${this.memberForm.lastName}
          &background=${background}&color=${color}&size=500&font-size=.35&bold=true`;

        if (this.memberForm.role) {
          form.UserRoles = [{ roleId: this.memberForm.role.id }];
        }

        if (this.editMember) {
          const { avatar, password, confirmPassword, ...editForm } = {
            ...form
          };
          editForm.UserRoles[0].id = this.singleMember.Roles[0].UserRole.id;
          editForm.UserRoles[0].userId = this.singleMember.id;
          this.USER_EDIT({ form: editForm, id: this.editMemberId })
            .then(() => {
              this.$toastr.success("Changes has been saved.", "Success");

              this.$emit("close");
            })
            .finally(() => {
              this.$set(this.$data, "isLoading", false);
            });
        } else {
          const logContent = `New member ${form.firstName} ${form.lastName}
            has been registered by ${this.currentUser}`;

          this.USER_ADD(form)
            .then(this.USER_SET_TAB(0))
            .then(socketSender("newMember", logContent))
            .then(() => {
              this.$toastr.success("Your changes are saved", "Success");

              // Redirect to member details view.
              if (this.$router.currentRoute.name !== "members") {
                const { activeUser: user } = this.$store.state.admin;

                this.$router.push({
                  name: "members",
                  params: { user }
                });
              }
            })
            .then(() => {
              this.$emit("close");
            })
            .finally(() => {
              this.$set(this.$data, "isLoading", false);
            });
        }
      } catch (error) {
        console.error(error);
        this.$toastr.error(error.message);
        this.$set(this.$data, "isLoading", false);
      }
    },
    handleTogglePasswordClick() {
      this.isToggled = !this.isToggled;
    },
    async fetchRoles() {
      try {
        let {
          data: { data }
        } = await axios.get("/roles");

        if (!data.length) return;

        const roles = data
          .filter(role => role.value < 1 || role.value >= 8)
          .sort((a, b) => (a.name > b.name ? 1 : -1));

        this.$set(this.$data, "userRoles", roles);
        return roles;
      } catch (error) {
        return error;
      }
    },
    generateDisplayName({ target }) {
      const displayName = target.value.trim().split(/\W/g)[0];
      this.$set(this.memberForm, "displayName", displayName);
      return displayName;
    }
  }
};
</script>

<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}

.form-group {
  .password-wrapper {
    position: relative;
    img {
      cursor: pointer;
      position: absolute;
      right: 0.75em;
      top: 11px;
      transition: all 0.2s ease;
      &:hover,
      &.is-visible {
        filter: brightness(50%);
      }
    }
  }
  label {
    font-weight: 500;
    font-size: $font-size-xs;
  }
  input {
    border-radius: 5px;
    color: $gray-800;
    font-family: "Gotham Book", sans-serif;
    font-size: $font-size-xs;
    &.invalid {
      border-color: red;
    }
    &.valid {
      border-color: none;
    }
  }
  ul {
    font-size: $font-size-xs;
  }
}

.form {
  &__submit-button {
    max-width: 7em;
  }
}

.dropdown-toggle {
  .vs__actions {
    button.clear {
      display: none;
    }
  }
  &::after {
    display: none !important;
  }
}
</style>
